<template>
  <div>
    <a-page-header
      :title="record.user"
      sub-title="合同编辑"
      @back="handleGoBack">
    </a-page-header>
    <a-form :form="form">
      <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          v-decorator="['company', {rules: [{required: true, message: '请输入'}, {max:128, message: '输入不符合长度限制'}]}]"
          placeholder="公司名称"/>
      </a-form-item>
      <a-form-item label="合同始期" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-date-picker
          v-decorator="['start_date', {rules: [{required: true, message: '请输入'}]}]"
          show-time
          format="YYYY-MM-DD"
          placeholder="合同始期"
          value-format="yyyy-MM-DD"
        />
      </a-form-item>
      <a-form-item label="合同年限" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-number v-decorator="['contract_years', {rules: [{required: true, message: '请输入'}]}]" placeholder="合同年限" :min="1"/>
      </a-form-item>
      <a-form-item
        v-bind="buttonCol"
      >
        <a-row>
          <a-col span="6">
            <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
          </a-col>
          <a-col span="10">
            <a-button @click="handleGoBack">返回</a-button>
          </a-col>
          <a-col span="8"></a-col>
        </a-row>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { oaEmployContractUpdate } from '@/api/oa_contract'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          values.end_date = this.calculateEndDate(values.start_date, values.contract_years)
          oaEmployContractUpdate(values, this.record.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
              }
            })
        }
      })
    },
    calculateEndDate (startDate, years) {
      // 将开始时间转换为 Date 对象
      const start = new Date(startDate)
      // 计算结束时间
      const end = new Date(start)
      end.setFullYear(start.getFullYear() + years)
      // 格式化结束时间为 YYYY-MM-DD
      const year = end.getFullYear()
      const month = String(end.getMonth() + 1).padStart(2, '0') // 月份从 0 开始，需要加 1
      const day = String(end.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    loadEditInfo (data) {
      const { form } = this
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['id', 'company', 'start_date', 'contract_years'])
        this.id = formData.id
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
